<template>
  <div class="chart-block">
    <h3>
         <a :href="url" target="_blank"> {{chartName}}</a>
      <span> {{updated}}</span></h3>
    <div id="chart_ne_per" class="chart-box"></div>
  </div>
</template>
<script>
import echarts from "echarts";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import {formatDate,strToFormatDate,strToYeayAndMonth } from '@/plugins/DateTimeFormater.js';
export default {
  props: {
    chartName: {
      type: String,
      default: "新能源销量占比"
    }
  },
  data() {
    return {
      url:"",
      chartOption: {},
      chartInfo: null,
      myChart: null,
      chartId: "new_energy_sales_pie",
      updated:''
    };
  },
  mounted() {
    this.chartOption = {
      color: ["#4ebdea", "#a7def3", "#327ed4", "#5aa0b3"],
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      legend: {
        show: false,
        right: 30,
        data: ["增程式电动", "插电式混合动力", "油电混合动力", "纯电动"]
      },
      series: [
        {
          name: "各新能源类型占比",
          type: "pie",
          radius: "50%",
          center: ["50%", "50%"],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }
      ]
    };
    this.getChartList({handle:this.updateChart});
  },
  methods: {
    ...mapActions("home", ["queryChartConfigs", "queryChartUpdate","getChartList"]),
    updateChart() {
      this.myChart = echarts.init(document.getElementById("chart_ne_per"));
      var info = this.getChartByName(this.chartId);
      this.chartOption.series[0].data = eval(info.jsonData);
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", function() {
         this.myChart && this.myChart.resize();
      });
         
      this.updated = `${strToYeayAndMonth(info.lastUpdated)}更新`;
        
       
    }
  },

  computed: {
    ...mapGetters("home", {chartList: "chartList",getChartByName: "getChartByName"}),
  },
  watch: {},
  created() {}
};
</script>
 <<style  scoped>
 #chart_ne_per{ width:100%;}
 </style>